function ThreeDotsVertical() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="31"
      height="31"
      fill="none"
      viewBox="0 0 31 31"
    >
      <rect
        width="30.6"
        height="30.6"
        fill="#696969"
        fillOpacity="0.16"
        rx="15.3"
      ></rect>
      <path
        fill="#fff"
        d="M15.3 16.075a.775.775 0 100-1.55.775.775 0 000 1.55zM15.3 10.65a.775.775 0 100-1.55.775.775 0 000 1.55zM15.3 21.5a.775.775 0 100-1.55.775.775 0 000 1.55z"
      ></path>
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M15.3 16.075a.775.775 0 100-1.55.775.775 0 000 1.55zM15.3 10.65a.775.775 0 100-1.55.775.775 0 000 1.55zM15.3 21.5a.775.775 0 100-1.55.775.775 0 000 1.55z"
      ></path>
    </svg>
  );
}

export default ThreeDotsVertical;